import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import appReducer from './appSlice';
import { apiSlice } from '../features/api';
import { filterReducer } from '../features/filter';

const listenerMiddleware = createListenerMiddleware();

export const store = configureStore({
  reducer: {
    app: appReducer,
    filter: filterReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
